import React, { FC, forwardRef } from 'react';
import MuiTabs from '@material-ui/core/Tabs';
import { TabsProps } from './types';
import useStyles from './styles';

const Tabs: FC<TabsProps> = forwardRef(({
  children,
  value,
  onChange,
  ...restProps
}, ref) => {
  const classes = useStyles();
  return (
    <MuiTabs
      ref={ref}
      value={value}
      onChange={onChange}
      scrollButtons='auto'
      variant='scrollable'
      classes={classes}
      {...restProps}
    >
      {children}
    </MuiTabs>
  );
});

export default Tabs;
